<template>
  <div class="wrapper" id="wap">

    <header class="flex-wrap pageTop">
      <div id="header">
        <div class="header-inner">
          <h1><a href="index.html"><img width="382" height="56" src="../../static/images/logo.png" alt="小白保险logo" title="小白保险"/></a></h1>

        </div>
      </div>
    </header>
    <main class="contentModule">
      <transition name="router-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
    <footer>
      <div id="footer">
        <ul id="nav">
          <el-menu
            :default-active="'0'"
            mode="horizontal"
            @select="handleSelect"
            background-color="#4c4c4c"
            text-color="#fff"
            active-text-color="#ffd04b">
            <el-menu-item index="1">首页</el-menu-item>
            <el-menu-item index="2" >领航达人</el-menu-item>
            <el-menu-item index="3">关于我们</el-menu-item>
            <el-menu-item index="4">下载客户端</el-menu-item>
            <el-menu-item index="5">服务与帮助</el-menu-item>
            <el-menu-item index="6">加入我们</el-menu-item>
            <el-menu-item index="7">联系我们</el-menu-item>
            <el-menu-item index="8" >隐私政策</el-menu-item>
            <el-menu-item index="9" >小白云服</el-menu-item>
          </el-menu>
        </ul>
        <div class="ban"><a style="color:#b2b2b2" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备13035223号</a></div>
        <div class="ban-left">正迅保险经纪有限公司  </div>
      </div>
    </footer>
  </div>
</template>

<script>

    export default {
        name: "wap",
        data() {
            return {
                current: 'index',
                name: '',
                styleShow: "display:block",
                styleShowTwo: "display:none",
            }
        },
        methods: {
            handleSelect(key, keyPath) {
                // alert(key, keyPath);
                $('html, body').css('overflow', 'auto');
                $('html, body').css('background-color', 'white');
                switch (key.toString()) {
                    case "1":
                        $('html, body').css('overflow', 'hidden');
                        this.$router.push({name: 'indexFirst'});
                        this.styleShow = "display:block";
                        this.styleShowTwo = "display:none";
                        break;
                    case "2":
                        this.$router.push({name: 'pilotProgram'});
                        break;
                    case "3":
                        this.styleShow = "display:none";
                        this.styleShowTwo = "display:block";
                        this.$router.push({name: 'about'});
                        break;
                    case "4":
                        this.styleShow = "display:none";
                        this.styleShowTwo = "display:block";
                        this.$router.push({name: 'download'});
                        break;
                    case "5":
                        this.styleShow = "display:none";
                        this.styleShowTwo = "display:block";
                        this.$router.push({name: 'server'});
                        break;
                    case "6":
                        this.styleShow =  "display:none";
                        this.styleShowTwo = "display:block";
                        this.$router.push({name: 'join'});
                        break;
                    case "7":
                        this.styleShow =  "display:none";
                        this.styleShowTwo = "display:block";
                        this.$router.push({name: 'contact'});
                        break;
                    case "8":
                        window.open("https://pic.xiaobaibao.com/system/reportTemp/2020/2/1e97d731774e48f7aa36bcbdc16b0ef0.pdf");
                        break;
                    case "9":
                        window.open("https://xbyf.xiaobaibao.com");
                        break;
                }
            }
        }
    }
</script>

<style scoped>
  @import "../../static/css/rcMain/index_ie.css";
  @import "../../static/css/rcMain/about.css";
  @import "../../static/css/rcMain/common.css";
  /deep/ .el-menu.el-menu--horizontal{
    border-bottom: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/wap.vue